export const brandKitGettingStartedArticle = {
  title: 'Brand Kit Creator: Getting Started',
  slug: 'brand-kit-getting-started',
  content: `Brand Kit Creator: Getting Started

Build a full brand kit across name, logo, signatures, and stationery.

1) Open the brand kit workflow
- Go to /marketing/brand-kit-creator.
- Tabs use URL hashes (for example #logo-design).

2) Create your brand name
- Start on the Business Name tab.
- Enter business name, tagline, industry, and description.

3) Design the logo
- Use Logo Design to generate a logo and set primary/accent colors.

4) Build collateral
- Email Signature, Letterhead, and Compliments Slip tabs let you craft branded assets.

5) Download the kit
- Use the Download Kit tab to export assets once you’re ready.
`,
};
